<template>
  <div class="auth-wrap">
    <div v-if="!$route.query.hasOwnProperty('code')" class="auth-header">
      <img src="@/assets/images/icon/tdeal_bi.png" />
      <h5 class="auth-logo">
        <i class="fa fa-circle text-primary"></i>
        Partner Admin
        <i class="fa fa-circle text-danger"></i>
      </h5>
      <b-button block variant="primary" @click.prevent="goToNcpLogin">로그인</b-button>
      <h6 class="mt-4">로그인 시 NCP 로그인 화면으로 이동합니다.</h6>
    </div>
    <b-modal v-model="loading" body-class="rounded-modal" id="ncp-modal" centered hide-header hide-footer no-fade no-close-on-backdrop>
      <div class="text-center mt-5 mb-5">
        <b-spinner class="mb-3"></b-spinner>
        <h6 class="mb-0">NCP 로그인 화면으로 이동합니다.</h6>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Widget from '@/components/widget/Widget'
import config from '@/config'

export default {
  name: 'LoginPage',
  components: { Widget },
  data() {
    return {
      errorMessage: null,
      loading: false,
      loginUrl: `https://partner.shopby.co.kr/login?systemKey=${config.ncpOAuthParams.systemKey}&appMallCode=${config.ncpOAuthParams.appMallCode}&redirectUrl=${config.ncpOAuthParams.redirectUrl}`
    }
  },
  computed: {
    ...mapGetters('authentication', ['getUserInitPage'])
  },
  methods: {
    goToNcpLogin() {
      this.loading = true
      setTimeout(() => {
        location.href = this.loginUrl
      }, 1000)
    }
  },
  created() {
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        this.loading = false
      }
    })
    if (this.$route.query && this.$route.query.hasOwnProperty('code')) {
      if (this.$route.query.code === '200') {
        this.$store.dispatch('authentication/getAdminInfo').then(res => {
          if (res && res.data && !res.data.code) {
            this.$store.commit('authentication/SET_USER', res.data)
            this.$router.replace(this.getUserInitPage)
          } else {
            alert('프로필 정보를 불러오지 못했습니다. 다시 시도해 주세요.')
            this.$router.replace('/login')
          }
        })
      } else {
        alert('로그인 화면을 불러오지 못했습니다. 다시 시도해 주세요.')
        this.$router.replace('/login')
        return
      }
    }
  }
}
</script>
